<template>
  <section class="cart-container">
    <div class="flex flex-between content-max-width">
      <div class="cart-content">

        <div v-if="cart.items == 0">
            <p style="padding: 30px 30px 0; text-align: center;">Your cart is empty</p>
        </div>

          <div v-for="(item, index) in cart.items" :key="item.id" class="flex cart-item">

            <div class="remove"
                @click="removeCartItem(index, item.key, item.title)"
            >
                <img src="/images/icons/remove.svg" alt="">
            </div>

            <div class="image" :style="'background-image: url('+item.image+');'"></div>

            <div class="description">
              <p class="title">{{ item.title }}</p>
              <p class="price">${{ item.price }}</p>
            </div>
            <div class="right-grp">
              <div class="quantity">
                  <number-input
                      :value="item.quantity"
                      @input="updateQuantity(index, $event)"
                  />
              </div>
              <div class="amount">
                  <p>
                      ${{ getFormattedPrice(item.quantity, item.price) }}
                  </p>
              </div>
            </div>
          </div>
      </div>

      <div class="cart-summary" >
        <div class="subtotal">
          <div class="s-row flex flex-between items-end">
              <p class="title">Subtotal</p>
              <p class="price">${{ getFormatAmount(cart.subTotalAmount) }}</p>
          </div>
          <div class="s-row flex flex-between items-end">
              <p class="title">GST</p>
              <p class="price">${{ getFormatAmount(cart.gstAmount.toFixed(2)) }}</p>
          </div>
        </div>
        <div class="total flex flex-between items-end">
            <p class="title">TOTAL <span class="incl-gst">(incl GST)</span></p>
            <p class="price">${{getFormatAmount(cart.subTotalAmount)}}</p>
        </div>
        <p class="note">Shipping calculated at checkout</p>
        <a class="button" href="/checkout" v-if="cart.subTotalAmount">Checkout</a>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      cart: {
        items: [],
        shippingInfo: {},
        billingInfo: {},
        coupons: [],
        totalAmount: 0.0,
        gstAmount: 0.0,
        shippingFree: 0.0,
        shippingDefault: 0.0,
        shippingAmount: 0.0,
        couponAmount: 0.0,
        subTotalAmount: 0.0,
        gstPercent: 0.0,
        hasFreightCalculations: true,
        hasFreightRegionLookup:true,
        gstInclusive: false,
      },
      removeButton: false,
      quantityInput: false,
    };
  },
  mounted() {
    this.loadCart()
  },
  methods: {
    loadCart () {
      window.axios.get('/cart?ajax=1')
        .then((res) => {
          this.$store.commit('setCart', res.data.data)
          this.cart = this.$store.state.cart
        })
    },

    getFormattedPrice (qty, price) {
      let total = qty * price;
      return this.getFormatAmount(total)
    },

    getFormatAmount (value) {
      let amount = parseFloat(value)
      return amount
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    removeCartItem (index, key, title) {
      this.removeButton = true

      if ( confirm("Press OK if you want to delete " + title + " from cart") ) {
        window.axios.delete('/cart/' + key)
          .then((res) => {
            this.$store.commit('setCart', res.data.data)
            this.cart = this.$store.state.cart
            this.removeButton = false
          })
          .catch((error) => {
            this.$store.commit('setPopup', {
              open: true,
              content: '<p>' + error.response.data.message + '</p>'
            })
            this.removeButton = false
          })
      } else {
        this.removeButton = false
      }
    },

    goToCheckout() {
      this.disableButton = true
      window.location.href = '/checkout'
    },

    updateQuantity (index, quantity) {
      // update the item quantity
      this.cart.items[index].quantity = quantity
      this.quantityInput = true

      // make sure quantity is not less than 1
      if (quantity < 1) {
        this.cart.items[index].quantity = 1
      }

      // update item quantity
      let payload = {
        key: this.cart.items[index].key,
        quantity: this.cart.items[index].quantity,
      }

      window.axios.put('/cart/', payload)
        .then((res) => {
          this.$store.commit('setCart', res.data.data)
          this.cart = this.$store.state.cart
          this.quantityInput = false
        })
        .catch((error) => {
          this.$store.commit('setPopup', {
            open: true,
            content: '<p>' + error.response.data.message + '</p>'
          })
          this.quantityInput = false
        })
    }
  },
};
</script>

<style scoped>
  .incl-gst {
    font-size: 10px;
  }
</style>



// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-cart/CartPage.vue